// numberOfBetsCheck receives string retruns string 
export const numberOfBetsCheck = (n: string): string => {
    if (typeof n !== 'string') return ''
    if (n.trim() === '') return ''
    if (isNaN(+n)) return ''
    if (+n < 0) return ''
    if (+n % 1 !== 0) return ''
    return n
}

export const percentCheck = (n: string) => {
    if (typeof n !== 'string') return '0'
    if (n.trim() === '') return '0'
    if (isNaN(+n)) return '0'
    return n
}

export const stopOnCheck = (n: string) => {
    if (typeof n !== 'string') return '0'
    if (n.trim() === '') return '0'
    if (isNaN(+n)) return '0'
    if (+n < 0) return '0'
    return n
}
